// Redux
import {
    types
} from './types';

import map from 'lodash/map';

// Firebase
import firebase from '../firebase/firebase';
const db = firebase.database();

// Moment
const moment = require('moment-timezone');

// Utility Functions 
import {
    getUserTimezone,
    convertDateTimeToUserTimezone
} from '../utils/timezoneUtils';
import getSbmClient, {
    getAsyncSbmClient
} from '../utils/getSbmClient';
import {
    utils
} from '../constants';

const {
    toTimestamp,
    toDateString
} = utils;

// const sbmClient = getSbmClient();
let sbmClientRefresh;
const SBMClient = getSbmClient((sbmClientRf) => {
    sbmClientRefresh = sbmClientRf;
});

// console.log(`%c${JSON.stringify(services)} are SERVICES`,'color: greenyellow');
// const additionalFieldsActivated = sbmClient.isPluginActivated('event_field');
// MIGHT BE ABLE TO JUST USE MY OWN, LATER IT MAY BE BENEFICIAL TO USE SBMs FORMS BUT I DOUBT IT

// Use refreshed sbmClient if there is one by passing all sbm requests to these object methods
const sbmClientProps = {
    getIsPlugin: () => {
        return (sbmClientRefresh) ?
            sbmClientRefresh.isPluginActivated('event_field') :
            SBMClient.isPluginActivated('event_field');
    },
    getUnitList: (cb) => {
        return (sbmClientRefresh) ?
            sbmClientRefresh.getUnitList((units) => {
                cb(units);
            }) :
            SBMClient.getUnitList((units) => {
                cb(units);
            });
    },
    getFirstWorkingDay: (selectedProvider, cb) => {
        return SBMClient.getFirstWorkingDay(selectedProvider, cb);
    },
    getWorkCalendar: (year, month, selectedProvider) => {
        return (sbmClientRefresh) ?
            sbmClientRefresh.getWorkCalendar(year, month, selectedProvider) :
            SBMClient.getWorkCalendar(year, month, selectedProvider);
    },
    getStartTimeMatrix: (startDay, endDay, sbmServiceId, selectedProvider, count, cb) => {
        return (sbmClientRefresh) ?
            sbmClientRefresh.getStartTimeMatrix(startDay, endDay, sbmServiceId, selectedProvider, count, (data) => {
                cb(data);
            }) :
            SBMClient.getStartTimeMatrix(startDay, endDay, sbmServiceId, selectedProvider, count, (data) => {
                cb(data);
            });
    },
    getEventList: () => {
        return (sbmClientRefresh) ?
            sbmClientRefresh.getEventList() :
            SBMClient.getEventList();
    },
    getCompanyTimezoneOffset: () => {
        return (sbmClientRefresh) ?
            sbmClientRefresh.getCompanyTimezoneOffset().timezone :
            SBMClient.getCompanyTimezoneOffset().timezone;
    },
    getAdditionalFields: (eventId) => {
        return (sbmClientRefresh) ?
            sbmClientRefresh.getAdditionalFields(eventId) :
            SBMClient.getAdditionalFields(eventId);
    }
}

// GET SERVICES
const services = sbmClientProps.getEventList(); // NOTE ALL SERVICES MUST BE MARKED VISIBLE IN SBM UI
// console.log('SBM SERVICES', services);

const pros = SBMClient.getUnitList(); // NOTE ALL PROVIDERS MUST BE MARKED VISIBLE IN SBM UI
// console.log('SBM PROVIDERS', pros);

// GET COMPANY TIMEZONE
if (!SBMClient) {
    alert('YOU HAVE NO CLIENT');
}
const companyTimezone = sbmClientProps.getCompanyTimezoneOffset();
// console.log(`%cCOMPANY TIMEZONE: ${JSON.stringify(companyTimezone)}`,'color: deeppink');
const userTimezone = getUserTimezone();

export const getAdditionalFields = (eventId) => async dispatch => {
    if (sbmClientProps.getIsPlugin()) {
        const arrayOfFields = await sbmClientProps.getAdditionalFields(eventId);
        // console.log('Additional Fields Are: ', arrayOfFields);
        // console.log(arrayOfFields);
    }
    // Note: this function is merely logging out the proprty names of the fields so I can manually use those property names and attach my own data values to them
}

export const getSBMProviders = () => dispatch => {
    // TODO: this needs to be more efficient than just grabbing every provider bc that might get very large and slow
    // console.log('GET ALL SBM PROVIDERS');
    sbmClientProps.getUnitList((units) => {
        const providerUnits = {
            ...units
        };

        dispatch({
            type: types.GET_ALL_SBM_PROVIDERS,
            payload: providerUnits
        })
    })
}

export const getCalendar = (providerId, serviceId, newDate) => async dispatch => {
    if (!providerId || !serviceId) {
        throw new Error('getCalendar requires providerId and serviceId arguments. Instead it received:', providerId, serviceId)
    }
    // CALLING THIS HERE IN ATTEMPT TO SEE IF IT WILL GET A FRESH TOKEN EACH TIME GET CALENDAR IS CALLED - CALENDAR SEEMS TO BE THE ONLY AFFECTED SMB FUNCTION BY EXPIRED TOKENS
    let sbmClient = getSbmClient((sbmClientRf) => {
        if (sbmClientRf) {
            sbmClient = sbmClientRf;
        }
    });

    // console.log('SBM REFRESHED/NORMAL CLIENT @ getCalendar', sbmClientRefresh, sbmClient);

    return new Promise((resolve, reject) => {
        // if (sbmClient) {
        //     console.log('WE HAVE A SBM CLIENT @ get calendar: ', sbmClient);
        // } else {
        //     console.log('GETTING SBM CLIENT FAILED @ get Calendar: ', sbmClient);
        // }
        // Get List Of Providers So We Can Find Our Chosen Provider
        // console.log('GET UNIT LIST');
        sbmClient.getUnitList(units => {
            // console.log('UNITS', units);

            const providers = {
                ...units
            };
            let workCalendar = {};
            // console.log('PROVIDERS IN CALENDAR', providers);

            const selectedProviderData = providers && providers[providerId];
            let selectedProvider = providers && providers[providerId] && providers[providerId].id;
            // console.log(providers[providerId].id, providerId, selectedProvider, '###############');
            // console.log('PROVIDERS', providers);
            // console.log('GET FIRST WORKING DAY');
            sbmClient.getFirstWorkingDay(selectedProvider, (dateString) => {
                // console.log('dateString', dateString)
                // console.log('selectedProvider', selectedProvider)
                const dateTimeString = moment(dateString, 'YYYY-MM-DD').format('YYYY-MM-DD HH:mm:ss');
                const localFirstWorkingDate = convertDateTimeToUserTimezone(dateTimeString, userTimezone, companyTimezone).format('YYYY-MM-DD');

                let date = newDate || localFirstWorkingDate;
                // console.log('thedate', date);

                const firstWorkingDateArr = date.split('-');

                // console.log('GET WORKING CALENDAR');
                workCalendar = sbmClient.getWorkCalendar(firstWorkingDateArr[0], firstWorkingDateArr[1], selectedProvider);

                const startMoment = moment(date, 'YYYY-MM-DD');
                const startDate = startMoment.format('YYYY-MM-DD');

                const startOfTodayTimestamp = parseInt(startMoment.format('x'), 10);

                // Get next week's date.
                const nextWeekMoment = startMoment.clone().add(6, 'days');

                // Get dates 1 day before startDate and one day after end date.
                const startMomentMinusOneDay = startMoment.clone().subtract(1, 'day');
                const startDateMinusOneDay = startMomentMinusOneDay.format('YYYY-MM-DD');

                const endMomentPlusOneDay = nextWeekMoment.clone().add(1, 'day');
                const endDatePlusOneDay = endMomentPlusOneDay.format('YYYY-MM-DD');

                const nextWeekStartDateMinusOneDay = startMomentMinusOneDay.clone().add(7, 'days').format('YYYY-MM-DD');
                const nextWeekEndDatePlusOneDay = endMomentPlusOneDay.clone().add(7, 'days').format('YYYY-MM-DD');

                const lastWeekStartDateMinusOneDay = startMomentMinusOneDay.clone().subtract(7, 'days').format('YYYY-MM-DD');
                const lastWeekEndDatePlusOneDay = endMomentPlusOneDay.clone().subtract(7, 'days').format('YYYY-MM-DD');

                const count = 1; // How many slots book

                // GET MATRIX DATA FOR THE WEEK FOLLOWING TO THE ONE BEING DISPLAYED ON THE CALENDAR
                const getNextWeekMatrix = sbmClient.getStartTimeMatrix(nextWeekStartDateMinusOneDay, nextWeekEndDatePlusOneDay, serviceId, selectedProvider, count, (matrixData) => {
                    const timesByDateArray = convertMatrixToLocalZone(matrixData);

                    dispatch({
                        type: types.RECEIVED_NEXT_CALENDAR,
                        payload: {
                            matrix: timesByDateArray,
                            calendarDetails: workCalendar,
                            firstWeekStartDate: toTimestamp(localFirstWorkingDate),
                            lastWeekStartDate: startDate, // the passed in date
                            thisWeekStartDate: startOfTodayTimestamp + moment.duration(1, 'week').asMilliseconds(),
                            nextWeekStartDate: startOfTodayTimestamp + moment.duration(2, 'weeks').asMilliseconds(),
                            providerId,
                            serviceId,
                            selectedProviderData
                        }
                    });

                    resolve();
                });

                // GET LAST WEEK
                // GET MATRIX DATA FOR THE WEEK PRIOR TO THE ONE BEING DISPLAYED ON THE CALENDAR
                // NOTE: THERE IS NO MATRIX BEFORE THE startDate
                const getLastWeekMatrix = sbmClient.getStartTimeMatrix(lastWeekStartDateMinusOneDay, lastWeekEndDatePlusOneDay, serviceId, selectedProvider, count, (matrixData) => {
                    const timesByDateArray = convertMatrixToLocalZone(matrixData);
                    console.log('firstWorkingDate', localFirstWorkingDate, moment(localFirstWorkingDate, 'YYYY-MM-DD').format('ddd YYYY-MM-DD'));
                    console.log('startOfToday', moment(startOfTodayTimestamp, 'x').format('ddd YYYY-MM-DD'));
                    console.log('startDate (date given by calling component)', startDate, moment(startDate, 'YYYY-MM-DD').format('ddd YYYY-MM-DD'));
                    dispatch({
                        type: types.RECEIVED_LAST_CALENDAR,
                        payload: {
                            matrix: timesByDateArray,
                            calendarDetails: workCalendar,
                            firstWeekStartDate: toTimestamp(localFirstWorkingDate),
                            lastWeekStartDate: startOfTodayTimestamp - moment.duration(2, 'weeks').asMilliseconds(),
                            thisWeekStartDate: startOfTodayTimestamp - moment.duration(1, 'week').asMilliseconds(),
                            nextWeekStartDate: startDate, // the passed in date
                            providerId,
                            serviceId,
                            selectedProviderData
                        }
                    });

                    resolve();
                });

                // GET THE MATRIX FOR CURRENT WEEK THAT IS DISPLAYING ON THE CALENDAR
                var startMatrix = sbmClient.getStartTimeMatrix(startDateMinusOneDay, endDatePlusOneDay, serviceId, selectedProvider, count, (standardDateStringsMatrix) => {

                    const {
                        userLocalTimestampMatrix,
                        standardTimestampMatrix
                    } = getLocalAndStandardTimestampsMatricesFromStandardDateStringsMatrix(standardDateStringsMatrix);

                    const isWestOfStandard = userLocalTimestampMatrix[0] < standardTimestampMatrix[0];

                    const isFirstCalendarPage = startDate === localFirstWorkingDate;
                    const daysToAdvance =
                        isFirstCalendarPage ?
                        (isWestOfStandard ? 9 : 8) :
                        7;

                    const timesByDateArray = convertMatrixToLocalZone(standardDateStringsMatrix, isFirstCalendarPage);

                    dispatch({
                        type: types.RECEIVED_CALENDAR,
                        payload: {
                            matrix: timesByDateArray,
                            calendarDetails: workCalendar,
                            firstWeekStartDate: toTimestamp(localFirstWorkingDate),
                            lastWeekStartDate: startOfTodayTimestamp - moment.duration(7, 'days').asMilliseconds(),
                            thisWeekStartDate: startDate,
                            nextWeekStartDate: startOfTodayTimestamp + moment.duration(daysToAdvance, 'days').asMilliseconds(),
                            providerId,
                            serviceId,
                            selectedProviderData
                        }
                    });

                    resolve();
                });
                let calendarData = {
                    startMatrix
                }
            });
        });
    });
};

const getLocalAndStandardTimestampsMatricesFromStandardDateStringsMatrix = (matrix) => {
    let userLocalTimestampMatrix = [];
    let standardTimestampMatrix = [];

    for (let date in matrix) {
        if (date) {
            const bookingTimes = matrix[date];
            bookingTimes.map(time => {
                const userDateTime = convertDateTimeToUserTimezone(`${date} ${time}`, userTimezone, companyTimezone)
                const userTimestamp = moment(userDateTime).format('x');

                // console.log('Cyno Timestamp: ', moment(`${date} ${time}`).format());
                // console.log('User DateTime: ' + moment(userDateTime).format());
                userLocalTimestampMatrix.push(userTimestamp);

                // Get company matrix for comparison
                const companyDateTime = moment(`${date} ${time}`, 'YYYY-MM-DD HH:mm:ss').tz(companyTimezone);
                const companyTimestamp = companyDateTime.format('x')
                standardTimestampMatrix.push(companyTimestamp);
            })
        }
    }

    return {
        userLocalTimestampMatrix,
        standardTimestampMatrix,
    };
}

const getLocalTimesByDate = (userLocalTimestampMatrix) => {
    let timesByDate = {};

    userLocalTimestampMatrix.map(timestamp => {
        let dateString = moment(timestamp, 'x').format('YYYY-MM-DD');

        if (!timesByDate[dateString]) {
            timesByDate = {
                ...timesByDate,
                [`${dateString}`]: []
            }
        }

        timesByDate = {
            ...timesByDate,
            [`${dateString}`]: [...timesByDate[dateString], moment(timestamp, 'x').format('HH:mm:ss')]
        }
    });

    return timesByDate;
}

const convertTimesByDateToArray = (timesByDate) => {
    return map(timesByDate, (value, key) => ({
        key,
        value: [...value]
    }));
}

// Note: with this system there will be some times at the end of the seven day that are missing if the client is more west or missing items will  be on the very begginning of the day if you head east
const convertMatrixToLocalZone = (standardDateStringsMatrix, isFirstCalendarPage = null) => {
    const {
        userLocalTimestampMatrix,
        standardTimestampMatrix
    } = getLocalAndStandardTimestampsMatricesFromStandardDateStringsMatrix(standardDateStringsMatrix);

    const timesByDate = getLocalTimesByDate(userLocalTimestampMatrix)

    const timesByDateArray = convertTimesByDateToArray(timesByDate);

    const numberOfWeekdays = timesByDateArray.length;

    // HANDLE CORRECTLY REMOVING TIMEZONE CAP DAYS DEPENDING ON THE NUMBER ADDED
    if (numberOfWeekdays === 10) timesByDateArray.pop();

    // if (!isFirstCalendarPage && timesByDateArray.length > 7) {
    //     // LOCAL PERSON IS MORE WEST THAN ST JOHNS
    //     console.log('Hey, I\'m in a more westerly timezone than St. Johns');
    //     if (!isFirstCalendarPage) timesByDateArray.pop();
    // } else if (standardTimestampMatrix[0] === userLocalTimestampMatrix[0] && timesByDateArray.length > 7) {
    //     // LOCAL USER IS STANDARD TIMEZONE
    //     console.log('Hey I\'m in St. Johns!');
    //     if (!isFirstCalendarPage) timesByDateArray.pop();
    // } else if (standardTimestampMatrix[0] < userLocalTimestampMatrix[0] && timesByDateArray.length > 7) {
    //     // LOCAL USER IS MORE EAST THAN ST. JOHNS
    //     console.log('Hey I\'m in a more easterly timezone than St. Johns!');
    //     if (!isFirstCalendarPage) timesByDateArray.pop();
    // }

    if (!isFirstCalendarPage) timesByDateArray.pop();
    timesByDateArray.pop(); // always pop this one - far west you get a day with 6 but it doesn't affect usability

    // Pops if the numberOfWeekdays is still greater than 7
    if (numberOfWeekdays > 7) timesByDateArray.pop();

    return timesByDateArray;
}

// need start datetime and end datetime then get one day before and ahead then only include the timestamps within the start and end times


// WEBPACK FOOTER //
// ./src/js/actions/calendar-actions.js